import React from 'react';
import NavBar from './NavBar';
import Header from './Header';

const Layout = ({ children, title, icon, showBackButton = true }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 900);
  const [navbarHeight, setNavbarHeight] = React.useState(80);
  const user = JSON.parse(localStorage.getItem('user'));
  
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div style={isMobile ? {
      ...styles.mobileContainer,
      paddingBottom: `${navbarHeight}px`
    } : styles.desktopContainer}>
      
      <div style={isMobile ? styles.mobileContent : styles.desktopContent}>
        <Header 
          title={title} 
          icon={icon} 
          onBack={showBackButton ? handleGoBack : null} // Só passa a função se showBackButton for true
        />
        <div style={styles.contentWrapper}>
          {children}
        </div>
      </div>

      <div style={isMobile ? {
        ...styles.mobileNavbar,
        height: `${navbarHeight}px`
      } : null}>
        {user && <NavBar />}
      </div>
    </div>
  );
};

const styles = {
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#F0F3FF',
    position: 'relative',
    boxSizing: 'border-box',
    overflowX: 'hidden'
  },
  mobileContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflowY: 'auto',
    padding: '16px',
    paddingBottom: '24px' // Espaço extra no final
  },
  desktopContainer: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F0F3FF'
  },
  desktopContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '250px',
    width: 'calc(100% - 250px)'
  },
  contentWrapper: {
    width: '100%',
    maxWidth: 'none'
  },
  mobileNavbar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#F0F3FF',
    boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
  }
};

export default Layout;